import React, { useState } from "react";

const industryOptions = [
  "Manufacturing",
  "Retail",
  "Hospitals & Healthcare",
  "Hospitality",
  "Restaurants & QSR",
  "Government",
  "Education",
  "Other",
];

function NewsletterGuidePopup({ variant = "home" }) {
  const isPlatformVariant = variant === "platform";
  const [isVisible, setIsVisible] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    workEmail: "",
    companyName: "",
    employeeCount: "",
    industry: "",
  });

  if (!isVisible) {
    return null;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsVisible(false);
  };

  const updateField = (field) => (event) => {
    setFormData((currentData) => ({
      ...currentData,
      [field]: event.target.value,
    }));
  };

  return (
    <>
      <style>{`
        .pmd-guide-popup {
          background: #fff1e6;
          bottom: 24px;
          box-shadow: 0 20px 55px rgba(6, 26, 73, 0.12);
          box-sizing: border-box;
          color: #260000;
          left: 24px;
          max-width: calc(100vw - 48px);
          padding: 22px 26px 28px;
          position: fixed;
          width: 430px;
          z-index: 80;
        }

        .pmd-guide-popup.is-form {
          padding-top: 22px;
          width: 430px;
        }

        .pmd-guide-popup-close {
          align-items: center;
          background: transparent;
          border: 0;
          color: #000;
          cursor: pointer;
          display: flex;
          font: 700 28px/1 Arial, sans-serif;
          height: 28px;
          justify-content: center;
          padding: 0;
          position: absolute;
          right: 12px;
          top: 12px;
          width: 28px;
        }

        .pmd-guide-popup-title {
          color: #260000;
          font-family: "Cormorant Garamond", Georgia, serif;
          font-size: 28px;
          font-weight: 500;
          line-height: 1.1;
          margin: 4px 34px 18px 0;
        }

        .pmd-guide-popup-copy {
          color: #050505;
          font: 500 16px/1.42 "Manrope", Arial, sans-serif;
          margin: 0 0 30px;
          max-width: 365px;
        }

        .pmd-guide-popup-button {
          background: transparent;
          border: 2px solid #2b0000;
          color: #080000;
          cursor: pointer;
          display: inline-flex;
          font: 800 15px/1 "Manrope", Arial, sans-serif;
          justify-content: center;
          min-width: 200px;
          padding: 13px 20px;
          transition: background 160ms ease, color 160ms ease;
        }

        .pmd-guide-popup-button:hover {
          background: #2b0000;
          color: #fff;
        }

        .pmd-guide-form-intro {
          color: #050505;
          font: 500 16px/1.35 "Manrope", Arial, sans-serif;
          margin: 0 30px 18px 0;
        }

        .pmd-guide-name-row {
          display: grid;
          gap: 14px;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        }

        .pmd-guide-field {
          margin-bottom: 13px;
        }

        .pmd-guide-label {
          color: #000;
          display: block;
          font: 800 13px/1.25 "Manrope", Arial, sans-serif;
          margin-bottom: 6px;
        }

        .pmd-guide-label span {
          color: #ff4b14;
        }

        .pmd-guide-input,
        .pmd-guide-select {
          background: #fff;
          border: 1px solid #aeb4bd;
          border-radius: 4px;
          box-sizing: border-box;
          color: #061a49;
          display: block;
          font: 700 14px/1.2 "Manrope", Arial, sans-serif;
          height: 42px;
          padding: 0 10px;
          width: 100%;
        }

        .pmd-guide-input:focus,
        .pmd-guide-select:focus {
          border-color: #061a49;
          outline: 3px solid rgba(255, 75, 20, 0.2);
        }

        .pmd-guide-submit {
          background: #2b0000;
          border: 0;
          color: #fff;
          cursor: pointer;
          font: 800 15px/1 "Manrope", Arial, sans-serif;
          min-width: 112px;
          padding: 13px 22px;
        }

        .pmd-guide-recaptcha {
          color: #8f8f8f;
          font: italic 12px/1.35 "Manrope", Arial, sans-serif;
          margin: 20px 0 0;
        }

        @media (max-width: 640px) {
          .pmd-guide-popup {
            bottom: 16px;
            left: 16px;
            max-height: calc(100vh - 32px);
            max-width: calc(100vw - 32px);
            overflow-y: auto;
            padding: 26px 22px 30px;
            width: auto;
          }

          .pmd-guide-popup-title {
            font-size: 31px;
          }

          .pmd-guide-popup-copy,
          .pmd-guide-form-intro {
            font-size: 18px;
          }

          .pmd-guide-popup-button {
            font-size: 18px;
            min-width: 0;
            width: 100%;
          }

          .pmd-guide-name-row {
            gap: 0;
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <aside
        className={`pmd-guide-popup ${showForm ? "is-form" : ""} ${
          isPlatformVariant ? "is-platform-form" : ""
        }`}
        aria-live="polite"
      >
        <button
          className="pmd-guide-popup-close"
          type="button"
          aria-label="Close guide popup"
          onClick={() => setIsVisible(false)}
        >
          &times;
        </button>

        {showForm ? (
          <form onSubmit={handleSubmit}>
            <p className="pmd-guide-form-intro">
              Please tell us a little bit about yourself, so we know who and where to send our
              eBook to.
            </p>

            {isPlatformVariant && (
              <div className="pmd-guide-name-row">
                <div className="pmd-guide-field">
                  <label className="pmd-guide-label" htmlFor="guide-first-name">
                    First Name <span>*</span>
                  </label>
                  <input
                    className="pmd-guide-input"
                    id="guide-first-name"
                    name="firstName"
                    type="text"
                    value={formData.firstName}
                    onChange={updateField("firstName")}
                    required
                  />
                </div>

                <div className="pmd-guide-field">
                  <label className="pmd-guide-label" htmlFor="guide-last-name">
                    Last Name <span>*</span>
                  </label>
                  <input
                    className="pmd-guide-input"
                    id="guide-last-name"
                    name="lastName"
                    type="text"
                    value={formData.lastName}
                    onChange={updateField("lastName")}
                    required
                  />
                </div>
              </div>
            )}

            <div className="pmd-guide-field">
              <label className="pmd-guide-label" htmlFor="guide-work-email">
                Work Email <span>*</span>
              </label>
              <input
                className="pmd-guide-input"
                id="guide-work-email"
                name="workEmail"
                type="email"
                value={formData.workEmail}
                onChange={updateField("workEmail")}
                required
              />
            </div>

            {isPlatformVariant && (
              <>
                <div className="pmd-guide-field">
                  <label className="pmd-guide-label" htmlFor="guide-company-name">
                    Company Name <span>*</span>
                  </label>
                  <input
                    className="pmd-guide-input"
                    id="guide-company-name"
                    name="companyName"
                    type="text"
                    value={formData.companyName}
                    onChange={updateField("companyName")}
                    required
                  />
                </div>

                <div className="pmd-guide-field">
                  <label className="pmd-guide-label" htmlFor="guide-employee-count">
                    Number of Employees <span>*</span>
                  </label>
                  <input
                    className="pmd-guide-input"
                    id="guide-employee-count"
                    name="employeeCount"
                    type="number"
                    min="1"
                    value={formData.employeeCount}
                    onChange={updateField("employeeCount")}
                    required
                  />
                </div>
              </>
            )}

            <div className="pmd-guide-field">
              <label className="pmd-guide-label" htmlFor="guide-industry">
                Industry
              </label>
              <select
                className="pmd-guide-select"
                id="guide-industry"
                name="industry"
                value={formData.industry}
                onChange={updateField("industry")}
              >
                <option value="">Select...</option>
                {industryOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <button className="pmd-guide-submit" type="submit">
              Submit
            </button>

            <p className="pmd-guide-recaptcha">This site is protected by reCAPTCHA.</p>
          </form>
        ) : (
          <>
            <h2 className="pmd-guide-popup-title">Evaluating On-Demand Pay Vendors?</h2>
            <p className="pmd-guide-popup-copy">
              Learn the basics of On-Demand Pay, how to evaluate potential vendors, and the
              On-Demand Pay features your company needs to ensure success.
            </p>
            <button className="pmd-guide-popup-button" type="button" onClick={() => setShowForm(true)}>
              Download the Guide
            </button>
          </>
        )}
      </aside>
    </>
  );
}

export default NewsletterGuidePopup;
